<template>
    <div class="why-marathon-block">
      <div class="msg-main">
        <div class="msg-1">
          <div class="msg-1-left">
            <div class="msg-1-title">
              <h1>为什么选择马拉松广告营销</h1>
              <a><img src="../../../assets/images/right-arrow.png"></a>
            </div>
            <div class="msg-1-sub-title">
              <h2>用户快速增长、海量品牌曝光</h2>
              <span>跑团邦是中国领先的马拉松照片服务商,与国内各大顶级赛事长期合作<br>
凭借马拉松赛事的影响力与马拉松照片的裂变传播的优势<br>
为客户提供马拉松全方位的营销资源,覆盖精准高端用户,自主快速传播。
            </span>
            </div>
            <router-link class="contact-btn" to="/home/ad-style">立即了解</router-link>
          </div>
          <div class="msg-1-right">
            <img src="../../../assets/images/marathon-way.png">
          </div>
        </div>
        <div class="msg-2">
          <div class="msg-2-left">
            <div>
              <h2>把广告展现给精准用户</h2>
              <span>
                用户属性:高学历，高收入，高消费<br/>
                用户需求:赛后93%参赛者查询下载照片<br/>
                传播方式:传播效率快，用户人群广，引流效果快
              </span>
            </div>
          </div>
          <div class="msg-2-right">
            <div>
              <h2>通过AI技术让投放更简单</h2>
              <span>
                人脸识别快速获取照片高频互动,多样化玩法
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'WhyMarathon'
}
</script>

<style scoped lang="stylus">
  .why-marathon-block
    width: 100%
    background-color: #eeeeee
    background-image: url("../../../assets/images/first-background.png")
    background-position: center
    background-size: cover
    .msg-main
      width: 84.4%;
      margin: 0 auto
      max-width: 1250px;
    .msg-1
      margin-left: 71px
      display: flex
      .msg-1-left
        display: inline-block
        vertical-align: top
        .msg-1-title
          h1
            padding-top: 55px
            font-weight: 400
            font-size: 32px
            display: inline-block
            margin: 0
          a
            display: inline-block
            vertical-align: bottom
            img
              width: 37px
              margin-left: 30px
              vertical-align: bottom
        .msg-1-sub-title
          h2
            margin-top: 83px
            font-weight: 400
            font-size: 22px
          span
            display: block
            margin-top: 34px
            font-size: 17px
            line-height: 27px
            width: 556px
        .contact-btn
          display: inline-block
          margin-top: 80px
          width: 209px
          height: 48px
          line-height: 48px
          text-align: center
          border-radius: 25px
          background-color: #e32232
          border: none
          color: white
          font-size: 20px
          text-decoration: none
      .msg-1-right
        display: inline-block
        margin-left: 20px
        img
          width: 100%
          /*width: 520px*/
          margin-top: 20px
    .msg-2
      display: flex
      margin: 70px 0 0 66px;
      .msg-2-left
        width: 525px;
        height: 543px;
        background-image: url("../../../assets/images/accurate-user.png")
        background-position: center
        background-size: cover
        display: inline-block
        position: relative
        margin-bottom: 10px
        div
          position: absolute
          left: 49px;
          bottom: 40px
          h2
            font-size: 20px
            font-weight: 400
          span
            font-size: 16px
            line-height: 25px
            color: #3a3a3a
            margin-top: 34px

      .msg-2-right
        margin-left: 80px;
        width: 525px;
        height: 543px;
        background-image: url("../../../assets/images/ai-put.png")
        background-position: center
        background-size: cover
        display: inline-block
        position: relative
        margin-bottom: 10px
        div
          position: absolute
          left: 49px;
          bottom: 75px
          h2
            font-size: 20px
            font-weight: 400
          span
            font-size: 16px
            line-height: 25px
            color: #3a3a3a
            margin-top: 34px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/WhyMarathon.vue